<template>
  <status-select :options="options" :record="record" record_type="modification" />
</template>

<script>
  import { modificationStatuses } from 'shared/statuses'
  import StatusSelect from '../../shared/components/status-select'
  export default {
    props: [ 'record' ],
    data () {
      return { options: modificationStatuses }
    },
    components: {
      StatusSelect
    }
  }
</script>
